import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { UserIcon, MailIcon, PhoneIcon, LockIcon, EyeIcon, EyeOffIcon } from 'lucide-react';
interface SignUpPageProps {
  onNavigate: (page: string) => void;
}
export function SignUpPage({
  onNavigate
}: SignUpPageProps) {
  const [showPassword, setShowPassword] = useState(false);
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} transition={{
    duration: 0.4
  }} className="min-h-screen bg-cream flex flex-col items-center justify-center py-12 px-4 sm:px-6 lg:px-8" data-id="element-614">
      <div className="max-w-md w-full bg-white rounded-3xl shadow-xl border border-amber/10 p-8" data-id="element-615">
        <div className="text-center mb-8" data-id="element-616">
          <div className="flex justify-center mb-4" data-id="element-617">
            <img src="https://cdn.magicpatterns.com/uploads/64it8njJxRLMTBC7zyqg6G/VICTORY-LOGO-TRANSPARENT.png" alt="Victory Kitchen Z" className="h-16 w-auto" data-id="element-618" />
          </div>
          <h2 className="font-heading text-4xl text-charcoal uppercase tracking-wide" data-id="element-619">
            Create Account
          </h2>
          <p className="font-body text-charcoal/60 mt-2" data-id="element-620">
            Join Victory Rewards and earn points on every order.
          </p>
        </div>

        <form className="space-y-5" onSubmit={e => e.preventDefault()} data-id="element-621">
          <div data-id="element-622">
            <label className="block font-heading text-sm text-charcoal uppercase tracking-wide mb-2" data-id="element-623">
              Full Name
            </label>
            <div className="relative" data-id="element-624">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-625">
                <UserIcon className="h-5 w-5 text-charcoal/40" data-id="element-626" />
              </div>
              <input type="text" className="block w-full pl-10 pr-3 py-3 border border-charcoal/10 rounded-xl bg-light focus:outline-none focus:ring-2 focus:ring-amber focus:border-transparent font-body transition-all" placeholder="John Doe" data-id="element-627" />
            </div>
          </div>

          <div data-id="element-628">
            <label className="block font-heading text-sm text-charcoal uppercase tracking-wide mb-2" data-id="element-629">
              Email Address
            </label>
            <div className="relative" data-id="element-630">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-631">
                <MailIcon className="h-5 w-5 text-charcoal/40" data-id="element-632" />
              </div>
              <input type="email" className="block w-full pl-10 pr-3 py-3 border border-charcoal/10 rounded-xl bg-light focus:outline-none focus:ring-2 focus:ring-amber focus:border-transparent font-body transition-all" placeholder="you@example.com" data-id="element-633" />
            </div>
          </div>

          <div data-id="element-634">
            <label className="block font-heading text-sm text-charcoal uppercase tracking-wide mb-2" data-id="element-635">
              Phone Number
            </label>
            <div className="relative" data-id="element-636">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-637">
                <PhoneIcon className="h-5 w-5 text-charcoal/40" data-id="element-638" />
              </div>
              <input type="tel" className="block w-full pl-10 pr-3 py-3 border border-charcoal/10 rounded-xl bg-light focus:outline-none focus:ring-2 focus:ring-amber focus:border-transparent font-body transition-all" placeholder="(555) 000-0000" data-id="element-639" />
            </div>
          </div>

          <div data-id="element-640">
            <label className="block font-heading text-sm text-charcoal uppercase tracking-wide mb-2" data-id="element-641">
              Password
            </label>
            <div className="relative" data-id="element-642">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-643">
                <LockIcon className="h-5 w-5 text-charcoal/40" data-id="element-644" />
              </div>
              <input type={showPassword ? 'text' : 'password'} className="block w-full pl-10 pr-10 py-3 border border-charcoal/10 rounded-xl bg-light focus:outline-none focus:ring-2 focus:ring-amber focus:border-transparent font-body transition-all" placeholder="••••••••" data-id="element-645" />
              <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute inset-y-0 right-0 pr-3 flex items-center text-charcoal/40 hover:text-charcoal transition-colors" data-id="element-646">
                {showPassword ? <EyeOffIcon className="h-5 w-5" data-id="element-647" /> : <EyeIcon className="h-5 w-5" data-id="element-648" />}
              </button>
            </div>
          </div>

          <div className="space-y-3 pt-2" data-id="element-649">
            <label className="flex items-start space-x-3 cursor-pointer group" data-id="element-650">
              <input type="checkbox" className="mt-1 w-4 h-4 text-amber rounded border-charcoal/20 focus:ring-amber" data-id="element-651" />
              <span className="font-body text-sm text-charcoal/70 group-hover:text-charcoal transition-colors" data-id="element-652">
                I agree to the Terms & Conditions and Privacy Policy
              </span>
            </label>
            <label className="flex items-start space-x-3 cursor-pointer group" data-id="element-653">
              <input type="checkbox" defaultChecked className="mt-1 w-4 h-4 text-amber rounded border-charcoal/20 focus:ring-amber" data-id="element-654" />
              <span className="font-body text-sm text-charcoal/70 group-hover:text-charcoal transition-colors" data-id="element-655">
                Sign me up for Victory Rewards to earn free food
              </span>
            </label>
          </div>

          <button type="submit" className="w-full bg-victory-red hover:bg-red-700 text-white font-heading text-xl py-4 rounded-xl shadow-lg transition-colors uppercase tracking-wider mt-4" data-id="element-656">
            Create Account
          </button>
        </form>

        <p className="mt-8 text-center font-body text-charcoal/60" data-id="element-657">
          Already have an account?{' '}
          <button onClick={() => onNavigate('signin')} className="text-amber font-bold hover:underline" data-id="element-658">
            Sign In
          </button>
        </p>
      </div>
    </motion.div>;
}